import { api } from './client';

/**
 * Подтипы марафонов у куратора — админская сторона D40 (договор
 * `docs/CONTRACTS/curator-groups.md` §1).
 *
 * ⚠️ РОЛИ РАЗНЫЕ У ЧТЕНИЯ И ЗАПИСИ: смотреть может admin и manager, ставить —
 * только admin. Поэтому экран прячет кнопку сохранения у менеджера: иначе он
 * нажимает и получает 403 ни за что.
 *
 * ⚠️ ПОДТИП САМОГО КУРСА ЭТИ РУЧКИ НЕ МЕНЯЮТ — его ставит только владелец (D29).
 * Здесь речь о том, какие подтипы «открыты» конкретному куратору.
 */

/** Подтип живого курса и курсы, которые под него попадают. */
export type SubtypeAvailable = {
  subtype: string;
  marathons: { id: string; title: string; access_category: string | null }[];
};

export type SubtypesView = {
  curator_id: string;
  /** Подтипы куратора по алфавиту. */
  subtypes: string[];
  /** Из чего выбирает админ. Курс без подтипа сюда не попадает. */
  available: SubtypeAvailable[];
};

export const adminSubtypesApi = {
  async get(userId: string): Promise<SubtypesView> {
    const { data } = await api.get(`/admin/users/${userId}/subtypes`);
    return data as SubtypesView;
  },

  /**
   * ПОЛНАЯ ЗАМЕНА списка, а не добавление: сервер перезаписывает набор целиком
   * (§1). Пустой массив снимает все подтипы.
   */
  async put(userId: string, subtypes: string[]): Promise<SubtypesView> {
    const { data } = await api.put(`/admin/users/${userId}/subtypes`, { subtypes });
    return data as SubtypesView;
  },
};
